import { useMemo } from 'react';

import { prepareMediaPlanRows } from '../utils/campaignsBuilder.js';
import { useCampaignCurrencyMode } from './useCampaignCurrencyMode.js';
import { useBuyingPlanRows } from './useGetBuyingPlanData.js';
import { useBuyingPlanMetaChannels } from './useGetBuyingPlanMetaData.js';
import { useCampaignDataSelector } from './useGetCampaignData.js';
import useGetPlatformIntegrations from './useGetPlatformIntegrations.js';
import { usePredictiveDataSelector } from './useGetPredictivePlanningData.js';
import { useStatusOfRows } from './useStatusOfRows.js';

export const useGetMediaPlanRows = () => {
  const rows = useBuyingPlanRows();
  const metaChannels = useBuyingPlanMetaChannels();
  const { data: predictiveData } = usePredictiveDataSelector('mediaRows');
  const [rowsStatus] = useStatusOfRows();

  const { data: journeyCurrency } = useCampaignDataSelector('currency');
  const [isCampaignCurrencyMode] = useCampaignCurrencyMode();
  const { integratedPlatforms } = useGetPlatformIntegrations();

  const preparedRows = useMemo(() => {
    if (!rows?.length || !integratedPlatforms) {
      return [];
    }

    return prepareMediaPlanRows({
      rows,
      journeyCurrency,
      metaChannels,
      predictiveData,
      rowsStatus,
      platformsIntegrations: integratedPlatforms,
      isCampaignCurrencyMode,
    });
  }, [
    rows,
    metaChannels,
    predictiveData,
    rowsStatus,
    journeyCurrency,
    isCampaignCurrencyMode,
    integratedPlatforms,
  ]);

  return preparedRows;
};
